import { useQuery } from '@tanstack/react-query';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useGetUser(id?: number, enabled = true) {
  return useQuery({
    queryKey: [UserKey.USERS, id],
    queryFn: () => UserService.getUser(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
